import { pagination_params } from '@/shared/utils/pagination_params';

export const getParamsUrl = (params) => {
  if (!params) return '';
  let path = '';
  path = pagination_params(params);
  params.Descripcion &&
    (path = `${path !== '' ? `${path}&` : ''}Descripcion=${params.Descripcion}`);
  params.RecursoTipo &&
    params.RecursoTipo.Codigo &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoRecursoTipo=${params.RecursoTipo.Codigo}`);
  if (params.Activo !== null) {
    path = `${path ? `${path}&` : ''}Activo=${params.Activo}`;
  }
  params.CodigoProceso &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoProceso=${params.CodigoProceso}`);
  return path;
};
